import { render, staticRenderFns } from "./PncpItems.vue?vue&type=template&id=6d7593d4&"
import script from "./PncpItems.vue?vue&type=script&lang=js&"
export * from "./PncpItems.vue?vue&type=script&lang=js&"
import style0 from "./PncpItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports